import { createReducer } from 'redux-act';
import * as actions from "modules/actions";

export interface ITriviaStatsContestQuestion {
	id: number;
	roundId: number;
	question_title: string;
	correct_answer_choices: string[];
	percent: number;
}

export interface ITriviaStatsContestRound {
	id: number;
	round_name: string;
	percent: number;
}

export interface ITriviaStatsContest {
	hardest_question: ITriviaStatsContestQuestion,
	easiest_question: ITriviaStatsContestQuestion,
	hardest_round: ITriviaStatsContestRound,
	easiest_round: ITriviaStatsContestRound,
}

export interface ITriviaStats {
	contest: ITriviaStatsContest;
}

const defaultState: ITriviaStats = {
	contest: {
		hardest_question: {
			id: 0,
			roundId: 0,
			question_title: '',
			correct_answer_choices: [],
			percent: 0,
		},
		easiest_question: {
			id: 0,
			roundId: 0,
			question_title: '',
			correct_answer_choices: [],
			percent: 0,
		},
		hardest_round: {
			id: 0,
			round_name: '',
			percent: 0,
		},
		easiest_round: {
			id: 0,
			round_name: '',
			percent: 0,
		},
	},
};

export const trivia_stats = createReducer<ITriviaStats>({}, defaultState)
	.on(actions.fetchContestStatSuccess, (state, payload) => ({
		...state,
		contest: {
			...state.contest,
			...payload,
		},
	}))
;
